export {
  createHttpClient,
  type CreateHttpClientOptions,
  type HttpClientErrorHandlers,
  type Method,
  type RequestData,
} from "./createHttpClient";
export {
  apiRequest,
  axiosInstance,
  ensureAccessToken,
  fetcher,
  fetcherV2,
  noAuthAxiosInstance,
} from "./client";
export {
  DEFAULT_MEDIA_CDN_BASE_URL,
  buildMediaCdnUrl,
  buildMediaVariantCdnUrl,
  extractMediaKey,
  getMediaVariantKey,
} from "./cdn";
export {
  createMediaRequest,
  deleteMediaRequest,
  getMediaRequest,
  listMediaRequest,
  mediaRoutes,
  notifyMediaUploadedRequest,
  updateMediaRequest,
  useMedia,
  useMediaList,
  type CreateMediaDTO,
  type MediaListResponse,
  type MediaUploadUrlResponseDTO,
  type UpdateMediaDTO,
} from "./media";

export type { MediaVariant } from "@gogive/types";

export const jsonHeaders = (headers?: Record<string, string>) => ({
  "Content-Type": "application/json",
  ...(headers ?? {}),
});
